export default "__VITE_ASSET__226631a8__"